import { CarrierLogisticsWebServerClientConfigFactory } from '@amzn/coral-config_carrier-logistics-web-server';
import {
  CoralClientFactory,
  CoralFetchHandler,
  InterceptingHandler,
} from '@amzn/ihm-js-coral-client';
import {
  carrierLogisticsWebServerHttpBindingInterceptor,
  CarrierLogisticsWebServer,
} from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import RequestOptionsInterceptor from './RequestOptionsInterceptor';
import envHelper from '../config/env';

const clientFactory = new CoralClientFactory(
  [CarrierLogisticsWebServerClientConfigFactory],
  envHelper.getEnv(),
  new InterceptingHandler(new CoralFetchHandler(), [
    carrierLogisticsWebServerHttpBindingInterceptor,
    new RequestOptionsInterceptor(),
  ])
);

/**
 * Custom web server to override serialization/deserialization
 */
class CustomWebServer extends CarrierLogisticsWebServer {
  constructor(config, handler) {
    super(config, handler);
  }
}

const CarrierLogisticsWebServerClient = clientFactory.get(CustomWebServer);

export default CarrierLogisticsWebServerClient;
